import { useState, useEffect } from 'react';

export default function useWpSeoMeta(slug) {
  const [seoData, setSeoData] = useState(null);
  
  useEffect(() => {
    if (!slug) return;
    
    fetch(`${window.wpData.restUrl}react-pages/v1/page?slug=${slug}`, {
      headers: { 'X-WP-Nonce': window.wpData.nonce },
      credentials: 'same-origin'
    })
    .then(res => res.json())
    .then(data => {
      if (data && data.yoast) {
        setSeoData({
          title: data.yoast.title || data.title?.rendered || '',
          metaDesc: data.yoast.metadesc || '',
          opengraph: {
            title: data.yoast.opengraph_title || '',
            description: data.yoast.opengraph_description || '',
            image: data.yoast.opengraph_image || '',
            type: data.yoast.opengraph_type || ''
          },
          twitter: {
            card: data.yoast.twitter_card || '',
            title: data.yoast.twitter_title || '',
            description: data.yoast.twitter_description || '',
            image: data.yoast.twitter_image || ''
          },
          canonical: data.yoast.canonical || '',
          robots: data.yoast.robots || '',
          // Also include any custom meta boxes if needed
          metaBoxes: data.meta_boxes || {}
        });
      }
    })
    .catch(() => setSeoData(null));
  }, [slug]);
  
  return seoData;
}
